// to change navbarHeight or sidebarwith
// edit this AND src/components/variables.css as well
export const navbarHeight = '40px';
export const sidebarWidth = '240px';


